<div id="flashMessages" class="flash-messages">
    <div id="grayOutDiv" *ngIf='_grayOut && messages.length'></div>
    <div class="flash-message {{message.cssClass}}" *ngFor='let message of messages'>
      <p>{{message.text}}</p>
    </div>
</div>
